module.exports = __webpack_public_path__ + "static/media/3.d7c36b06.jpg";